import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, CONFERENCE_TYPE } from '../interfaces/Conference';

const { t } = useTranslations();

export const getConferenceTypeTranslationById = (id: CONFERENCE_TYPE) => {
    if (id === CONFERENCE_TYPE.EPI) return 'Epi konferencia';
    if (id === CONFERENCE_TYPE.PP) return 'PP konferencia';
    if (id === CONFERENCE_TYPE.DNA) return 'DNA lídra';
    if (id === CONFERENCE_TYPE.CSKONGRES) return 'CS kongres';
};

export const getTypeTranslationById = (id: COMPONENT_TYPE) => {
    if (id === COMPONENT_TYPE.HERO) return t('conference.component.hero.title');
    if (id === COMPONENT_TYPE.PERSONS) return t('conference.component.lecturers.title');
    if (id === COMPONENT_TYPE.PROGRAM) return t('conference.component.program.title');
    if (id === COMPONENT_TYPE.INVITATIONS) return t('conference.component.videoInventions.title');
    if (id === COMPONENT_TYPE.TICKETS) return t('conference.component.tickets.title');
    if (id === COMPONENT_TYPE.ACCOMODATION) return t('conference.component.accomodation.title');
    if (id === COMPONENT_TYPE.PARTNERS) return t('conference.component.partners.title');
    if (id === COMPONENT_TYPE.ARCHIVE) return t('conference.component.previous.title');
    if (id === COMPONENT_TYPE.REFERENCES) return t('conference.component.references.title');
    if (id === COMPONENT_TYPE.ATTACHMENTS) return t('conference.component.attachments.title');
    if (id === COMPONENT_TYPE.VIDEO) return t('conference.component.record.title');
    if (id === COMPONENT_TYPE.ABOUT) return t('conference.component.description.title');
    if (id === COMPONENT_TYPE.NOTICERECORDING) return t('conference.component.digitalRecordInfo.title');
    if (id === COMPONENT_TYPE.CONTACT) return t('conference.component.contact.title');
    if (id === COMPONENT_TYPE.ORDERFORMTICKET) return t('conference.component.orderForm.title');
    if (id === COMPONENT_TYPE.OPENEVENT) return t('conference.component.openEvent.title');
    if (id === COMPONENT_TYPE.PHOTOGALLERY) return t('conference.component.photogallery.title');
    if (id === COMPONENT_TYPE.REPORTAGEVIDEO) return t('conference.component.reportagevideo.title');
    if (id === COMPONENT_TYPE.STREAM) return t('conference.component.stream.title');
};
